import styled from 'styled-components'

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 500;
`

export const InfoIcon = styled.span`
  display: inline-flex;
  margin-right: 0.5em;
  flex-shrink: 0;

  svg {
    width: 1.35em;
    height: 1.35em;
    fill: ${props => props.theme.color.primary};
  }
`

export const InfoText = styled.span`
  min-width: 0;
  text-align: left;
`
